/* eslint-disable */
import $ from 'jquery';
require('normalize.css/normalize.css');
require('../css/main.scss');
require('./page.scss');
import 'regenerator-runtime/runtime';

$(document).ready(function() {

});